import { BFF_BASE_URL } from "../../../../../api/client";

/**
 * Opens the inline DMS Adjustment Sheet PDF using the browser's session cookie,
 * matching the Deal Summary PDF action.
 * @param {string} approvalId - The approval/deal ID.
 */
export function openDmsAdjustmentSheet(approvalId: string): void {
  const url = `${BFF_BASE_URL}/api/v1/workbench/${encodeURIComponent(approvalId)}/dms-adjustment-sheet/pdf`;
  window.open(url, "_blank");
}
